import React from "react"
import FieldProto from "../../../fields3/proto/field-proto"
import FieldConfig from "../../proto/field-config"
import FieldRating_View from "./render/view"
import FieldRating_QuickFilterView from "./render/quick-filter-view"
import FieldRating_ManagementForm from "./render/management-form"
import FieldRating_ManagementPreview from "./render/management-preview"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldRating_FormElement from "./render/form-element"
import FieldRating_GlistGroupModern from "./components/glist-group/modern"
import FieldRating_InlineEditable from "./render/inline-editable"
import FieldRating_AutomationTriggerForm from "./render/automation-trigger"
import FieldRating_AutomationConditionForm from "./render/automation-condition"
import FieldRating_AutomationActionForm from "./render/automation-action"
import FieldRating_GlistGroupStandard from "./components/glist-group/standard"
import normalizeNumber from "../../import/normalize/normalize-number"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldRating_GraphTickLabelView from "./render/graph-tick-label"
import FieldRating_FormElementView from "./render/form-element-view"
import FieldRating_Editable from "./render/editable/editable"
import {FieldFilterType, FieldGroupAllPossibleValues_Params} from "../../proto/types"
import FieldRating_ConditionForm from "./render/condition"
import {FIELD_CONDITIONS_DROPDOWN, FieldRating_filterFunc} from "../../conditions/dropdown"
import FieldRating_ViewGroup from "./render/group/group"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import FieldRating_AggregateCell from "./render/aggregate/aggregate-cell"
import GroupBy from "../../../gd/manager/group-by/group-by-model"
import FieldRating_BoardAggregate from "./render/aggregate/board-aggregate"
import FieldRating_TableCellCalculated from "./render/table/calculated/table-cell-calculated"

// const debug = "FieldRating"
const debug = false

export default class FieldRating extends FieldProto {

    FIELD_DEFAULT_WIDTH = 100;

    public scale        : number

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Rating";
        this.filterType                     = FieldFilterType.DROPDOWN;
        this.typeGroup                      = GROUP_MISC
        this.typeDescription                = "Rating select field"
        this.icon                           = 'i5-star-empty';

        // special
        this.scale                          = _.get(config,'scale',5);
        this.clearButton                    = _.get(config,'clearButton',true);

        this.isGroupByAvailable             = true
        this.isFilterAvailable              = true
        this.isGroupByAllOptionsAvailable   = true

        this.conditionTypes                 = FIELD_CONDITIONS_DROPDOWN

        // core/gd-form/common/form-manager
        this.formType                       = 'select';

        this.options                        = this.getAutomationOptions()

        this.hasCalculatedValues            = true

        _.assign(this.components,{

            glistGroupModern    : FieldRating_GlistGroupModern,
            glistGroupStandard  : FieldRating_GlistGroupStandard,

            ValueIcon: <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        })

        _.assign(this.renderComponents,{
            view                    : FieldRating_View,
            viewSmall               : FieldRating_View,

            inlineEditable          : FieldRating_InlineEditable,

            formElement             : FieldRating_FormElement,
            formElementView         : FieldRating_FormElementView,

            managementForm          : FieldRating_ManagementForm,
            managementPreview       : FieldRating_ManagementPreview,

            quickFilterView         : FieldRating_QuickFilterView,

            automationTriggerForm   : FieldRating_AutomationTriggerForm,
            automationConditionForm : FieldRating_AutomationConditionForm,
            automationActionForm    : FieldRating_AutomationActionForm,

            graphTickLabelView      : FieldRating_GraphTickLabelView,
        })

        this.renderComponents.view                      = FieldRating_View
        this.renderComponents.viewSmall                 = FieldRating_View

        this.renderComponents.inlineEditable            = FieldRating_InlineEditable

        this.renderComponents.formElement               = FieldRating_FormElement
        this.renderComponents.formElementView           = FieldRating_FormElementView

        this.renderComponents.managementForm            = FieldRating_ManagementForm
        this.renderComponents.managementPreview         = FieldRating_ManagementPreview

        this.renderComponents.quickFilterView           = FieldRating_QuickFilterView

        this.renderComponents.automationTriggerForm     = FieldRating_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldRating_AutomationConditionForm
        this.renderComponents.automationActionForm      = FieldRating_AutomationActionForm

        this.renderComponents.conditionForm             = FieldRating_ConditionForm
        this.renderComponents.filterForm                = FieldRating_ConditionForm

        this.renderComponents.graphTickLabelView        = FieldRating_GraphTickLabelView

        this.renderComponents.editable                  = FieldRating_Editable
        this.renderComponents.viewGroup                 = FieldRating_ViewGroup

        this.renderComponents.tableCellCalculated       = FieldRating_TableCellCalculated
        this.renderComponents.aggregateCell             = FieldRating_AggregateCell
        this.renderComponents.boardAggregate            = FieldRating_BoardAggregate

        this.filterFunc                                 = FieldRating_filterFunc
    }

    sortValue(value:any) { return _.isNil(value) ? 0 : value}

    // no search for rating
    // searchValue(value) { return value}

    getAutomationOptions(): any[] {
        const stars = new Array(this.scale + 1)
        const options : any[] = _.chain(stars)
            .map((m,key)=>({
                value: key,
                label: key
            }))
            .value()
        return options
    }

    normalizeToCSVValue(model: any): any {
        let res = super.normalizeToCSVValue(model)

        if (!_.isNil(res) && res > this.scale) {
            res = this.scale
        }

        return res
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeNumber(value)
    }

    toJson() {
        let result = super.toJson();
        result.scale    = this.scale;
        return result;
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.AVERAGE
    }

    /** GROUP BY **/
    groupValue(value:any) {
        let groupValue = _.isNil(value) ? null : typeof value === 'string' ? parseInt(value) : value
        if (_.isNaN(groupValue)) {
            groupValue = null
        }

        debug && console.log(debug, 'groupValue', value, groupValue)

        return groupValue
    }

    groupLabel(value: any): string {
        const groupValue = this.groupValue(value)

        debug && console.log(debug, 'groupLabel', groupValue, _.isNil(groupValue))

        let res
        if (_.isNil(groupValue)) {
            res = 'Not set'
        } else {
            if (groupValue === 1)   res = '1 star'
            else                    res = '{0} stars'.f(groupValue)
        }
        return res
    }

    groupSortValue(value:any, groupBy?:GroupBy) {
        return _.isNil(value) ? 0 : value
    }

    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        const res: Set<any> = new Set<any>
        res.add(null) // not selected value

        for(let i = 0; i < this.scale; i++) {
            res.add(i + 1)
        }

        return _.orderBy([...res],
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }
}
